import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Check, Times } from '../../../components/Icon';
import { Modal, ModalControls } from '../../../components/Modal';
import { Button } from '../../../components/Buttons';
import { addToCompany, deleteFromCompany, fetchCompanies } from '../actions';
import _ from 'lodash';
import { selectCompanies } from '../selectors';
import { Dropdown } from '../../../components/Dropdown';

const STATE = {
  value: '',
  addUserCompany: false,
  addValue: '',
  deleteCompanyConfirm: null,
  addCompanyId: null,
};

const Container = styled.div``;

const CompanyListItem = styled.div`
  > .box {
    align-items: center;
    border-bottom: 1px solid #ddd;
  }
  .name {
    margin-right: 12px;
    width: 200px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class UserCompaniesComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetchCompanies();
  }

  reset() {
    this.setState({ ...STATE });
  }

  get user() {
    return this.props.user;
  }

  get companies() {
    return this.props.companies;
  }

  addToCompany() {
    const userId = this.props.user.id;
    const companyId = this.state.addCompanyId;

    this.props.addToCompany(userId, companyId, this.reset.bind(this));
  }

  deleteFromCompany() {
    const { companyId, userId } = this.state.deleteCompanyConfirm;
    this.props.deleteFromCompany(userId, companyId, this.reset.bind(this));
  }

  render() {
    const user = this.props.user;
    if (!user) return null;
    if (!this.companies) return null;
    return (
      <Container>
        {this.renderAdd()}
        {this.renderDeleteFromCompany()}
        <h3>{this.lbl('user.details.companies')}:</h3>
        <div>
          <Button small onClick={this.setStateFn({ addUserCompany: true })}>
            +
          </Button>
        </div>
        <VBox>{user.companies.map(c => this.renderUserCompany(c, user.id))}</VBox>
      </Container>
    );
  }

  renderAdd() {
    if (true !== this.state.addUserCompany) {
      return null;
    }
    const attachedCompanies = this.user?.companies.map(c => c.id);
    const companiesOptions = this.companies
      .filter(c => !attachedCompanies.includes(c.id))
      .map(c => {
        const nameProperty = c.properties.find(p => p.name.name === 'name');
        const companyName = nameProperty?.value ?? null;
        return { value: c.id, label: companyName };
      });

    const selectedCompany = companiesOptions.find(o => this.state.addCompanyId === o.value);
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('user.property.add')}>
        <div>
          <div>Company</div>
          <Dropdown
            name="companyId"
            options={companiesOptions}
            value={selectedCompany}
            onChange={o => this.setState({ addCompanyId: o.value })}
          />
        </div>
        <ModalControls>
          <Button primary onClick={this.addToCompany.bind(this)}>
            Save
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderUserCompany(company, userId) {
    const nameProperty = company.properties.find(p => p.name.name === 'name');
    const companyName = nameProperty?.value ?? null;
    return (
      <CompanyListItem key={`${company.id}`}>
        <HBox>
          <div className="name">Name</div>
          <div className="value">{companyName === true ? <Check /> : companyName === false ? <Times /> : companyName}</div>
          <div className="name">
            <Button small onClick={this.setStateFn({ deleteCompanyConfirm: { companyId: company.id, userId } })}>
              <Times />
            </Button>
          </div>
        </HBox>
      </CompanyListItem>
    );
  }

  renderDeleteFromCompany() {
    if (!this.state.deleteCompanyConfirm) return null;
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('user.modal.delete.confirm.title')}>
        <ModalControls>
          <Button isPrimary onClick={this.deleteFromCompany.bind(this)}>
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }
}

UserCompaniesComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    companies: selectCompanies(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchCompanies() {
      dispatch(fetchCompanies());
    },
    addToCompany(userId, companyId, callback) {
      dispatch(addToCompany(userId, companyId, callback));
    },
    deleteFromCompany(userId, companyId, callback) {
      console.log('userId, companyId', { userId, companyId });
      dispatch(deleteFromCompany(userId, companyId, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const UserCompanies = compose(
  withConnect,
  withRouter,
)(UserCompaniesComp);
